module.exports = __webpack_public_path__ + "img/print-botao_pb.a89831f4.png";